/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as transectionService from '../../../services/transectionService'
class WithdrawModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         amount: null,
         remark: "",
         mpassword: "",
         toastMsg: "",
         toastType: ""
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
          setTimeout(() => {
              self.setState({ toastMsg: "", toastType: "", showToast: false })
          }, 3000);
      })
  }
   async submitData() {
      let data = {
         "depositAmount":parseFloat(this.state.amount),
         "username":this.props.user.username,
         "masterPassword": this.state.mpassword,
         "description": this.state.remark  
     }
     await transectionService.withdrawDeposit(data).then((res)=>{
        if(res.isSuccess){
         this.props.notify("Cash Out withdrawed successfully!", "success");
           this.props.closeAndUpdate()
        }else{
         this.props.notify(res.exception.message,"error");
        }
     })
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   componentDidMount() {
   }
   render() {
      return (
         <>
            <div classNameName="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Cash Out</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                        <div className="row m-b-20">
                           <div className="col-md-12" style={{"text-align":"center"}}>
                              <label>Current PL:<span style={{"color":"green"}}> {this.props.user.balance} </span></label> |
                              <label>Current Exposure:<span style={{"color":"red"}}>  {this.props.user.exposure} </span></label>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Amount</label>
                           </div>
                           <div className="col-md-8">
                              <input type="number" autoFocus tabIndex={1} name="amount" onChange={(e) => { this.change(e) }} className="maxlength10" value={this.state.amount} />
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Remarks</label>
                           </div>
                           <div className="col-md-8">
                              <textarea name="remark" tabIndex={2} id="deposit-remark" onChange={(e) => { this.change(e) }} value={this.state.remark}></textarea>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" tabIndex={3} name="mpassword" id="mpassword" onChange={(e) => { this.change(e) }} required="" />
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <a className="pop-edit-btn" onClick={()=>{this.submitData()}} style={{cursor: "pointer"}}>Submit</a>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} style={{cursor: "pointer"}} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>                        
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div classNameName="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(WithdrawModel);